import { getRudderstack } from '@ecomm/shared-window'
import { useCallback } from 'react'
import { useTracking } from 'react-tracking'

const seeDetailsClick = {
  GA: 'see-details-click-section',
  RS: 'see_details_click_section'
}
const seeDetailsFAQClick = {
  GA: 'see-details-faq-click',
  RS: 'see_details_faq_click'
}
const modalSections = new Set(['How it keeps you safe', 'Specs', 'FAQs'])

/**
 * Track clicks when the user clicks on any collapsible section of the BMS V3 modal.
 *
 * @param section - The section of the modal being viewed ('How it keeps you safe’ or ‘Specs’ or ‘FAQ’).
 * If the section is a FAQ, it should be the question title.
 * @param component - The device for which the section is being viewed.
 * @returns A callback function to track the click event.
 */
export function useTrackBMSv3ModalSectionClick(
  section: string,
  component: string
) {
  const { trackEvent } = useTracking()

  const isFAQ = !modalSections.has(section)
  const event = isFAQ ? seeDetailsFAQClick : seeDetailsClick

  const trackBMSv3ModalSectionClick = useCallback(
    (isSectionOpen: boolean) => {
      const label = isSectionOpen ? 'expand' : 'collapse'
      const properties = {
        label,
        section,
        component
      }

      trackEvent({
        event: event.GA,
        ...properties
      })

      getRudderstack(r => {
        r.track(event.RS, properties)
      })
    },
    [component, event, section, trackEvent]
  )

  return trackBMSv3ModalSectionClick
}
